/**
 * Generated by orval 🍺
 * Do not edit manually.
 * GTA CRM Demo API
 * GTA CRM 生产级 demo 的只读+轻写 API(feat-008;demo-scoped,零 model 零迁移)。
 * OpenAPI spec version: 1.0.0
 */
import { BlankEnum } from "./blankEnum";
import { ProductFamilyEnum } from "./productFamilyEnum";

export const WonReceiptProductFamily = {
  ...ProductFamilyEnum,
  ...BlankEnum,
} as const;
